<template>
  <v-hover>
    <v-card v-if="title" slot-scope="{ hover }" :class="`elevation-${hover ? 6 : 2} rounded-lg mt-10 mx-auto`" v-bind="$attrs" max-width="350px" shaped align="center">
      <v-flex fill-height row justify-center align-center v-if="title">
        <v-btn :color="color" :max-height="icon ? 90 : undefined" class="disable-pointer" dark elevation="2" fab x-large absolute>
          <v-icon class="white--text" x-large if="icon" size="36" v-text="icon" />
        </v-btn>
      </v-flex>
      <v-list class="rounded-lg" v-if="title">
        <v-list-item class="mt-14">
          <v-list-item-content class="pt-0">
            <v-list-item-title align="center" class="font-weight-normal display-2">
              {{ value }}
            </v-list-item-title>
            <v-list-item-title align="center" class="font-weight-regular title" v-text="title"> </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-if="goIcon" class="ma-0 pa-0">
        <v-list-item>
          <v-list-item-content>
            <div class="d-flex justify-end">
              <v-icon if="icon" v-text="goIcon" />
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-if="$slots.actions">
        <v-card-actions class="pb-0">
          <slot name="actions" />
        </v-card-actions>
      </template>
    </v-card>
    <v-card v-else slot-scope="{ hover }" :class="`elevation-${hover ? 6 : 2} rounded-lg mx-auto`" v-bind="$attrs" max-width="350px" shaped>
      <v-flex justify-space-between class="pa-4" fill-height row v-if="cardTitle">
        <v-btn :color="color" :max-height="icon ? 90 : undefined" class="disable-pointer" dark large elevation="0" fab absolute left>
          <v-icon class="white--text" x-large if="icon" size="36" v-text="icon" />
        </v-btn>
        <v-card-title class="font-weight-regular title mb-0 ml-16 pl-6" v-text="cardTitle"> </v-card-title>
        <div class="d-flex justify-end align-end" style="width:100%;">
          <v-icon v-if="gotoIcon" v-text="gotoIcon"></v-icon>
        </div>
      </v-flex>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'ClickableCard',

  props: {
    subtitle: {
      type: String,
      default: undefined
    },
    cardTitle: {
      type: String,
      default: undefined
    },

    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: undefined
    },
    goIcon: {
      type: String,
      default: undefined
    },
    gotoIcon: {
      type: String,
      default: undefined
    },
    text: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: undefined
    },
    smallValue: {
      type: Number,
      default: undefined
    }
  },

  computed: {}
}
</script>
